<template>
  <b-card class="card-box card__mc-card" body-class="py-3">
    <b-row style="min-height: 395.92px" class="align-content-between">
      <b-col cols="12" class="p-0">
        <div class="d-flex flex-row" style="height: 100px">
          <b-col cols="4">
            <badge-image v-if="badgeImageSrc" :src="badgeImageSrc"></badge-image>
          </b-col>
          <b-col cols="8">
            <div class="text-right w-100">
              <b-badge
                v-if="status"
                pill
                :variant="badgeStatusVariant(status)"
                class="py-1 card__status"
              >
                <span class="text__submission-status">{{ readableStatus(status) }}</span>
              </b-badge>
            </div>
          </b-col>
        </div>
        <b-col
          v-if="learningUnit && learningUnit.level_type"
          class="text-primary font-weight-bold mt-4"
        >
          <span class="mr-1"
            ><img
              :src="
                learningUnit.level_type === 'CAREER_SPECIFIC'
                  ? require('@/assets/learning-unit-types/specific.svg')
                  : require('@/assets/learning-unit-types/academic.svg')
              "
              style="height: 16px"
            />
          </span>
          <span class="text__mc-type">{{
            learningUnit.level_type === 'CAREER_SPECIFIC' ? 'Career Specific' : 'Academic Focused'
          }}</span>
        </b-col>
        <b-col
          class="h5 font-weight-bold mt-4 text__mc-title card__title-truncate-overflow"
          cols="12"
          >{{ learningUnit.name }}
        </b-col>
      </b-col>

      <b-col class="p-0">
        <b-col cols="12">
          <hr class="mb-3" />
        </b-col>

        <b-col v-if="mode == 'LEARN_VERIFY'" cols="12" class="mb-2">
          <div class="text-black-50">
            Learning Completed {{ progressPercent ? progressPercent : 0 }}%
          </div>
          <b-progress height="4px" :value="progressPercent" :max="100"></b-progress>
        </b-col>

        <b-col v-if="mode == 'LEARN_VERIFY'" cols="12">
          <b-button
            class="w-100"
            :class="
              progressPercent && progressPercent == '100'
                ? 'button__view-your-learning'
                : 'button__go-to-learning'
            "
            variant="primary"
            @click="onLearning"
            >{{
              progressPercent && progressPercent == '100' ? 'View your learning' : 'Go to learning'
            }}</b-button
          >
        </b-col>
        <b-col cols="12">
          <b-button
            class="w-100 my-2"
            :class="
              status == 'AWARDED' ? 'button__go-to-badge-collection' : 'button__verify-competency'
            "
            variant="outline-primary"
            @click="onVerify"
            >{{ status == 'AWARDED' ? 'Go to badge collection' : 'Verify competency' }}</b-button
          >
        </b-col>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import EvidenceSubmission from '@/models/EvidenceSubmission';
import Upload from '@/models/Upload';
import { notificationMixin } from '@/mixins/notificationMixin';
import BadgeImage from '../Credential/BadgeImage.vue';

export default {
  components: {
    BadgeImage
  },

  mixins: [notificationMixin],

  props: {
    mode: {
      type: String,
      default: ''
    },
    status: {
      type: String,
      default: ''
    },
    learningUnit: {
      type: Object,
      default: () => ({})
    },
    lastestEvidence: {
      type: Object,
      default: () => ({})
    },
    progressPercent: {
      type: [Number, String],
      default: 0
    },
    view: {
      type: String,
      default: 'learner'
    }
  },

  data() {
    return {
      badgeImageSrc: null
    };
  },

  computed: {
    defaultSection() {
      return this.learningUnit && this.learningUnit.sections
        ? this.learningUnit.sections.find((lu) => lu.is_default === true)
        : null;
    }
  },

  async mounted() {
    if (
      this.learningUnit &&
      this.learningUnit.badge_image &&
      this.learningUnit.badge_image.length
    ) {
      const { response } = await Upload.api().fetchPresignedUrl(
        this.learningUnit.badge_image[0].id
      );

      this.badgeImageSrc = response.data.url;
    }
  },

  methods: {
    badgeStatusVariant(status) {
      let variant;

      switch (status) {
        case 'NOT_SUBMITTED':
          variant = 'dark';
          break;

        case 'REVIEW_PENDING':
          variant = 'warning';
          break;

        case 'DENIED':
          variant = 'danger';
          break;

        case 'AWARDED':
          variant = 'success';
          break;

        default:
          variant = '';
          break;
      }

      return variant;
    },

    readableStatus(key = '') {
      if (this.view == 'learner' && key == 'AWARDED') key = 'ACHIEVED';
      return EvidenceSubmission.STATUS[key];
    },

    onVerify() {
      if (this.status == 'AWARDED') {
        window.location.href = `/badge-collection?learningUnitId=${this.learningUnit.id}`;
      } else {
        this.$router.push({
          name: 'learning-unit/method-components',
          params: {
            learningUnitId: this.learningUnit.id
          }
        });
      }
    },

    onLearning() {
      if (this.defaultSection) {
        this.$router.push({
          name: 'learning-unit/feed',
          params: {
            learningUnitId: this.learningUnit.id,
            sectionId: this.defaultSection.id
          }
        });
      } else {
        this.notiError();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.card__mc-card {
  min-height: 395.92px;
  max-height: 451.92px;
  width: 100%;
  height: auto;
}

.img__mc-badge {
  max-height: 100px;
  max-width: 89px;
}

.card__title-truncate-overflow {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.card__status {
  width: 100%;
  max-width: fit-content;
  height: auto;

  .text__submission-status {
    white-space: break-spaces;
  }
}
</style>
